module.exports = __webpack_public_path__ + "static/media/helper.ccfad5aa.jpg";